@if (googleApiUrl) {
  <iframe [@mapAnimation] frameborder="0" [src]="googleApiUrl" allowfullscreen></iframe>
}
<app-center-section>
  <h1>{{ title }}</h1>
  <div [innerHTML]="description | sanitizeHtml" class="page-description rich-text"></div>
  @if (!hideContactForm) {
    <form #formDirective="ngForm" [formGroup]="form" (ngSubmit)="postContactForm()" #contactForm="ngForm">
      @if (formContent.subjects?.length) {
        <div class="subjects">
          <label for="subjects"><span>*</span>Emne</label>
          <mat-radio-group id="subjects" [formControl]="form.controls.subject">
            @for (subject of formContent.subjects; track $index) {
              <mat-radio-button [value]="subject">{{ subject }}</mat-radio-button>
            }
          </mat-radio-group>
        </div>
      }
      <div class="inputs">
        <app-text-input
          [control]="form.controls.firstName"
          [directive]="contactForm"
          [name]="formContent.firstNameLabel"
          [placeholder]="formContent.firstNamePlaceholder"
        ></app-text-input>
        <app-text-input
          [control]="form.controls.lastName"
          [directive]="contactForm"
          [name]="formContent.lastNameLabel"
          [placeholder]="formContent.lastNamePlaceholder"
        ></app-text-input>
        <app-text-input
          [control]="form.controls.email"
          [directive]="contactForm"
          [name]="formContent.emailLabel"
          [placeholder]="formContent.emailPlaceholder"
        ></app-text-input>
        <app-text-input
          [control]="form.controls.phone"
          [directive]="contactForm"
          [name]="formContent.phoneLabel"
          [placeholder]="formContent.phonePlaceholder"
        ></app-text-input>
        <app-text-input
          class="large-field"
          [control]="form.controls.message"
          [directive]="contactForm"
          [name]="formContent.messageLabel"
          [placeholder]="formContent.messagePlaceholder"
          [textarea]="true"
          [minRows]="12"
          [maxRows]="12"
        ></app-text-input>
      </div>
      <app-text-button class="submit-button">{{ submitButton }}</app-text-button>
    </form>
  }
</app-center-section>
